import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close2",
  "use": "icon-close2-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"icon-close2\"><defs><style>#icon-close2 .cls-1{fill:#e52929;}</style></defs><title>关闭</title><path class=\"cls-1\" d=\"M50.45.1A49.45,49.45,0,1,0,99.9,49.55,49.46,49.46,0,0,0,50.45.1ZM70.83,69a2.87,2.87,0,0,1-3.92,0L51.36,53.42,35.8,69a2.77,2.77,0,1,1-3.91-3.92L47.44,49.51,32,34a2.76,2.76,0,0,1,3.91-3.91l15.5,15.49L66.85,30.1A2.77,2.77,0,1,1,70.77,34l-15.5,15.5L70.83,65.06A2.87,2.87,0,0,1,70.83,69Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol